import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("div", {
    staticClass: "wlc-space-between"
  }, [_c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm,
      size: "small"
    },
    nativeOn: {
      submit: function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "创建时间"
    }
  }, [_c("el-date-picker", {
    staticStyle: {
      width: "250px"
    },
    attrs: {
      type: "daterange",
      "range-separator": "至",
      "start-placeholder": "开始",
      "end-placeholder": "结束",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "picker-options": _vm.pickerOptions
    },
    on: {
      change: _vm.handleDateChange
    },
    model: {
      value: _vm.searchForm.time,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "time", $$v);
      },
      expression: "searchForm.time"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "咨询分类"
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "未选择",
      clearable: ""
    },
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.categoryCode,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "categoryCode", $$v);
      },
      expression: "searchForm.categoryCode"
    }
  }, _vm._l(_vm.categoryList, function (item) {
    return _c("el-option", {
      key: item.code,
      attrs: {
        label: item.labelCn,
        value: item.code
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "咨询状态"
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "未选择",
      clearable: ""
    },
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.status,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "status", $$v);
      },
      expression: "searchForm.status"
    }
  }, _vm._l(_vm.statusList, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "跟进人"
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "未选择",
      clearable: "",
      disabled: _vm.searchForm.status === 0
    },
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.followId,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "followId", $$v);
      },
      expression: "searchForm.followId"
    }
  }, _vm._l(_vm.followList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.serviceName,
        value: item.id
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "手机号"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入用户手机号"
    },
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "phone", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "searchForm.phone"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "用户昵称"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入用户昵称"
    },
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.nickName,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "nickName", $$v);
      },
      expression: "searchForm.nickName"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "星标记"
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "未选择",
      clearable: ""
    },
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.star,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "star", $$v);
      },
      expression: "searchForm.star"
    }
  }, [_c("el-option", {
    attrs: {
      label: "是",
      value: 1
    }
  }), _c("el-option", {
    attrs: {
      label: "否",
      value: 0
    }
  })], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "咨询编号"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入咨询编号"
    },
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.serialNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "serialNumber", $$v);
      },
      expression: "searchForm.serialNumber"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.getData("search");
      }
    }
  }, [_vm._v(" 搜索 ")]), _c("el-button", {
    attrs: {
      type: "warning"
    },
    on: {
      click: _vm.reset
    }
  }, [_vm._v("重置")])], 1)], 1), _c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm
    }
  })], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "serialNumber",
      label: "咨询编号",
      width: "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var _ref$row = _ref.row,
          serialNumber = _ref$row.serialNumber,
          status = _ref$row.status,
          star = _ref$row.star;
        return [_c("div", [_c("div", {
          staticClass: "serial-number"
        }, [_vm._v(" " + _vm._s(serialNumber) + " "), _c("i", {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: star,
            expression: "star"
          }],
          staticClass: "el-icon-star-on star-icon"
        })]), _c("div", {
          staticClass: "status",
          style: {
            backgroundColor: _vm.statusTags[status || 0].color
          }
        }, [_vm._v(" " + _vm._s(_vm.statusTags[status || 0].label) + " ")])])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "userName",
      label: "咨询用户",
      width: "170"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var _ref2$row = _ref2.row,
          userName = _ref2$row.userName,
          consultationCount = _ref2$row.consultationCount,
          phone = _ref2$row.phone,
          userInfo = _ref2$row.userInfo;
        return [_c("div", {
          staticClass: "consult-user wlc-f-c"
        }, [_c("wlc-user-pop", {
          attrs: {
            info: userInfo
          },
          on: {
            saveRemark: _vm.saveRemark
          }
        }), consultationCount > 1 ? _c("span", {
          staticClass: "count",
          on: {
            click: function click($event) {
              return _vm.selectCount(phone);
            }
          }
        }, [_vm._v(" ×" + _vm._s(consultationCount) + " ")]) : _vm._e()], 1), _c("div", {
          staticClass: "phone"
        }, [_vm._v("+" + _vm._s(userInfo.iso) + " " + _vm._s(phone))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "content",
      label: "咨询内容"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var _ref3$row = _ref3.row,
          content = _ref3$row.content,
          imgs = _ref3$row.imgs,
          video = _ref3$row.video,
          userId = _ref3$row.userId,
          id = _ref3$row.id,
          followCount = _ref3$row.followCount;
        return [_c("div", {
          staticClass: "wlc-pointer",
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return _vm.toDetail({
                userId: userId,
                id: id
              });
            }
          }
        }, [_c("div", {
          staticStyle: {
            "font-size": "12px"
          }
        }, [_vm._v(_vm._s(content))]), _c("div", {
          staticClass: "media-box"
        }, [followCount > 1 ? _c("aside", {
          staticClass: "reply-num"
        }, [_vm._v(" 跟进次数 " + _vm._s(followCount) + " ")]) : _vm._e(), imgs !== null && imgs !== void 0 && imgs.length || video ? [_c("el-popover", {
          attrs: {
            placement: "bottom-start",
            trigger: "hover"
          }
        }, [_c("div", {
          staticClass: "media wlc-f-c"
        }, [video ? _c("div", {
          staticClass: "video-list wlc-f-c"
        }, [_c("div", {
          staticClass: "video-box wlc-pointer",
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return _vm.previewVideo(video);
            }
          }
        }, [_c("video", {
          staticClass: "message-video",
          attrs: {
            src: video
          }
        }), _c("i", {
          staticClass: "play-icon el-icon-caret-right"
        })])]) : _vm._e(), _vm._l(imgs, function (item, index) {
          return _c("wlc-image", {
            key: item,
            attrs: {
              src: item,
              current: index,
              list: imgs,
              width: "76",
              compression: true
            }
          });
        })], 2), _c("div", {
          staticClass: "wlc-f-c wlc-pointer",
          attrs: {
            slot: "reference"
          },
          slot: "reference"
        }, [imgs !== null && imgs !== void 0 && imgs.length ? [_c("d2-icon-svg", {
          staticClass: "icon",
          attrs: {
            name: "img_icon"
          }
        }), _vm._v(" " + _vm._s(imgs.length) + " ")] : _vm._e(), video ? [_c("d2-icon-svg", {
          staticClass: "icon video-icon",
          attrs: {
            name: "video_icon"
          }
        }), _vm._v(" 1 ")] : _vm._e()], 2)])] : _vm._e()], 2)])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "followName",
      width: "140",
      label: "跟进人"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref4) {
        var followName = _ref4.row.followName;
        return [_vm._v(" " + _vm._s(followName || "-") + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "createDate",
      width: "160",
      label: "创建时间"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "120",
      align: "center",
      fixed: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref5) {
        var row = _ref5.row;
        return [_c("el-button", {
          attrs: {
            type: "text",
            size: "mini"
          },
          on: {
            click: function click($event) {
              return _vm.toDetail(row);
            }
          }
        }, [_vm._v("查看 ")]), _c("el-button", {
          attrs: {
            type: "text",
            size: "mini"
          },
          on: {
            click: function click($event) {
              return _vm.setStar(row);
            }
          }
        }, [_vm._v(" " + _vm._s(row.star ? "取消星标" : "设为星标") + " ")])];
      }
    }])
  })], 1), _c("div", {
    staticClass: "wlc-pagination"
  }, [_c("el-pagination", {
    key: _vm.searchForm.pageSize * _vm.searchForm.pageNum,
    attrs: {
      layout: "total, prev, pager, next",
      "page-size": _vm.searchForm.pageSize,
      "current-page": _vm.searchForm.pageNum,
      total: _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1), _c("video-preview", {
    ref: "videoPreview",
    attrs: {
      url: _vm.previewVideoUrl
    }
  }), _c("image-preview", {
    ref: "imgPreview",
    attrs: {
      imgs: _vm.imgArr,
      "initial-index": _vm.imgIndex
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };